// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiPayorRequest {
    static getAttributeTypeMap() {
        return MedicalBiPayorRequest.attributeTypeMap;
    }
}
MedicalBiPayorRequest.discriminator = undefined;
MedicalBiPayorRequest.additionalProperties = false;
MedicalBiPayorRequest.attributeTypeMap = [
    {
        "name": "groupId",
        "baseName": "groupId",
        "type": "string"
    },
    {
        "name": "groupName",
        "baseName": "groupName",
        "type": "string"
    },
    {
        "name": "id",
        "baseName": "id",
        "type": "string"
    },
    {
        "name": "memberId",
        "baseName": "memberId",
        "type": "string"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "otherInsuranceStatus",
        "baseName": "otherInsuranceStatus",
        "type": "string"
    },
];
//# sourceMappingURL=medicalBiPayorRequest.js.map